// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';

import styles from './ClosedCaptionsButton.module.scss';

const messages = {
  closedCaptioning: {
    id: 'tile.settings.closedCaptioning.header',
    description: 'closed captioning',
  },
  closedCaptioningOn: {
    id: 'tile.settings.closedCaptioning.on',
    description: 'closed captioning state on',
  },
  closedCaptioningOff: {
    id: 'tile.settings.closedCaptioning.off',
    description: 'closed captioning state off',
  },
};

const ClosedCaptionsButton = ({
  focusId,
  onClick,
  ttsText,
  isOnButton,
  isSelected,
}) => {
  const intl = useIntl();

  return (
    <Selectable
      focusId={focusId}
      className={styles.ccButton}
      ttsText={ttsText}
      onSelect={onClick}
      render={({ hasFocus }) => (
        <button
          type="button"
          onClick={onClick}
          className={classNames({
            [styles.focused]: hasFocus,
            [styles.selected]: isSelected,
          })}
          data-testid={`closed-captions-button-${isOnButton ? 'on' : 'off'}`}
        >
          <div className="d-flex align-items-center justify-content-center">
            <div
              data-testid="closed-captioning-icon"
              className={classNames(styles.ccIcon, isOnButton && styles.ccOn)}
            >
              {intl.formatMessage(messages.closedCaptioning)}
            </div>
            <div
              data-testid="closed-captioning-status"
              className="text-uppercase"
            >
              {intl.formatMessage(
                messages[
                  isOnButton ? 'closedCaptioningOn' : 'closedCaptioningOff'
                ],
              )}
            </div>
          </div>
        </button>
      )}
    />
  );
};

ClosedCaptionsButton.propTypes = {
  focusId: PropTypes.string,
  onClick: PropTypes.func,
  ttsText: PropTypes.string,
  isOnButton: PropTypes.bool,
  isSelected: PropTypes.bool,
};

ClosedCaptionsButton.defaultProps = {
  focusId: null,
  onClick: () => {},
  ttsText: '',
  isOnButton: false,
  isSelected: false,
};

export default React.memo(ClosedCaptionsButton);
